import { Mail, Phone, MapPin, Send, CheckCircle, X } from 'lucide-react';
import { useState, useEffect } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    setFormData({ name: '', email: '', message: '' });
    setShowPopup(true);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="contact" className="py-20 bg-dark-bg relative overflow-hidden">
      {/* Success Popup */}
      {showPopup && (
        <div className="fixed bottom-4 right-4 z-50 animate-slide-up">
          <div className="bg-dark-card border-2 border-toxic-green rounded-xl p-6 shadow-2xl max-w-sm">
            <div className="flex items-start space-x-4">
              <div className="bg-toxic-green/20 p-2 rounded-full flex-shrink-0">
                <CheckCircle className="w-6 h-6 text-toxic-green" />
              </div>
              <div className="flex-1">
                <h3 className="text-white font-bold mb-1">Message envoyé !</h3>
                <p className="text-gray-300 text-sm">
                  Merci pour votre message ! Nous vous répondrons dans les plus brefs délais.
                </p>
              </div>
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-400 hover:text-white transition-colors flex-shrink-0"
                aria-label="Fermer"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hexagonal background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 right-20 w-40 h-40 border-4 border-toxic-green rotate-45 transform"></div>
        <div className="absolute bottom-20 left-20 w-32 h-32 border-4 border-toxic-green rotate-45 transform"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Contactez-<span className="text-toxic-green">Nous</span>
          </h2>
          <p className="text-xl text-gray-400">
            Une question ? Une suggestion ? Nous sommes là pour vous aider
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold mb-6 text-white">Informations de Contact</h3>
              <p className="text-gray-400 mb-8 leading-relaxed">
                Notre équipe est disponible pour répondre à toutes vos questions concernant les plateformes de paris, les bonus, ou toute autre demande. N'hésitez pas à nous contacter.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4" itemScope itemType="http://schema.org/ContactPoint">
                <div className="bg-toxic-green/20 p-3 rounded-lg">
                  <Mail className="w-6 h-6 text-toxic-green" />
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-1">Email</h4>
                  <a href="mailto:info@hexabetconnect.com" itemProp="email" className="text-gray-400 hover:text-toxic-green transition-colors">
                    info@hexabetconnect.com
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4" itemScope itemType="http://schema.org/ContactPoint">
                <div className="bg-toxic-green/20 p-3 rounded-lg">
                  <Phone className="w-6 h-6 text-toxic-green" />
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-1">Téléphone</h4>
                  <a href="tel:+33421739833" itemProp="telephone" className="text-gray-400 hover:text-toxic-green transition-colors">
                    +33 4 21 73 98 33
                  </a>
                </div>
              </div>

             
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-white font-semibold mb-2">
                  Nom complet *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  autoComplete="name"
                  className="w-full px-4 py-3 bg-dark-bg border-2 border-gray-700 rounded-lg text-white focus:border-toxic-green focus:outline-none transition-colors"
                  placeholder="Votre nom"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-white font-semibold mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                  className="w-full px-4 py-3 bg-dark-bg border-2 border-gray-700 rounded-lg text-white focus:border-toxic-green focus:outline-none transition-colors"
                  placeholder="votre@email.com"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-white font-semibold mb-2">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  autoComplete="off"
                  className="w-full px-4 py-3 bg-dark-bg border-2 border-gray-700 rounded-lg text-white focus:border-toxic-green focus:outline-none transition-colors resize-none"
                  placeholder="Votre message..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full px-6 py-4 bg-toxic-green text-dark-bg font-bold rounded-lg hover:bg-opacity-80 transition-all transform hover:scale-105 flex items-center justify-center"
              >
                Envoyer le Message
                <Send className="ml-2 w-5 h-5" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

